export default "__VITE_ASSET__DCFREmTw__"